import { createContext } from 'react';
const ConfigContext = createContext();
export default ConfigContext